module.exports = __webpack_public_path__ + "img/d3.241f9901.jpg";